var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "diglog-card multi-withdraw-confirm-modal",
      attrs: {
        visible: _vm.dialogVisible,
        title: _vm.$t("data.withdraw_information_confirmation"),
        width: "560px",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        closed: _vm.handleDialogClosed,
      },
    },
    [
      _c("div", { staticClass: "header-line" }),
      _c("div", { staticClass: "confirm-details" }, [
        _c("div", { staticClass: "confirm-row" }, [
          _c("span", [_vm._v(_vm._s(_vm.$t("data.cash_out_amount")))]),
          _c("strong", [
            _vm._v(
              _vm._s(_vm.confirmData.currency) +
                " " +
                _vm._s(_vm.confirmData.formatted_amount)
            ),
          ]),
        ]),
        _c("div", { staticClass: "confirm-row" }, [
          _c("span", [_vm._v(_vm._s(_vm.$t("data.account")))]),
          _c("strong", [_vm._v(_vm._s(_vm.confirmData.account_label || "-"))]),
        ]),
        _c("div", { staticClass: "confirm-row" }, [
          _c("span", [_vm._v(_vm._s(_vm.$t("dashboard.fee")))]),
          _c("strong", [
            _vm._v(
              _vm._s(_vm.confirmData.arrival_currency) +
                " " +
                _vm._s(_vm.confirmData.formatted_fee)
            ),
          ]),
        ]),
        !_vm.hideUsdManualQuoteArrival
          ? _c("div", { staticClass: "confirm-row confirm-row--arrival" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("data.amount_received")))]),
              _c("div", [
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.confirmData.arrival_currency) +
                      " " +
                      _vm._s(_vm.confirmData.arrival_amount)
                  ),
                ]),
                _vm.showExchangeRate
                  ? _c("p", { staticClass: "exchange-rate" }, [
                      _vm._v(
                        " 1.00 " +
                          _vm._s(_vm.confirmData.arrival_currency) +
                          " = " +
                          _vm._s(_vm.confirmData.exchange_rate) +
                          " " +
                          _vm._s(_vm.confirmData.currency) +
                          " "
                      ),
                    ])
                  : _vm._e(),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm.$store.getters.isOpenMfa
        ? _c(
            "el-form",
            {
              ref: "confirmForm",
              staticClass: "mfa-form",
              attrs: {
                model: _vm.confirmForm,
                rules: _vm.rules,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("system.mfa_verify_code"),
                    prop: "verification_code",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "6",
                      placeholder: "Enter your MFA verification code",
                      autocomplete: "off",
                    },
                    model: {
                      value: _vm.confirmForm.verification_code,
                      callback: function ($$v) {
                        _vm.$set(_vm.confirmForm, "verification_code", $$v)
                      },
                      expression: "confirmForm.verification_code",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              staticClass: "btn-submit",
              attrs: { type: "info", loading: _vm.submitting },
              on: { click: _vm.onClickSubmit },
            },
            [_vm._v(" " + _vm._s(_vm.$t("components.submit")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }